import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/auth";
import AuthCallback from "./pages/AuthCallback";
import ResetPassword from "./pages/ResetPassword";
import AuthModal from "./components/auth/AuthModal";
import GuruPlus from "./pages/GuruPlus";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import CalculatorsIndex from "./pages/CalculatorsIndex";
import CategoryPage from "./pages/CategoryPage";
import CalculatorPage from "./pages/CalculatorPage";
import Products from "./pages/Products";
import ProductPage from "./pages/ProductPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AdminPage from "./pages/AdminPage";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { Privacy, Terms, DisclaimerPage } from "./pages/Legal";
import NotFound from "./pages/NotFound";
import { analytics, initGA4 } from "./lib/analytics/ga4";
import { applyLiveData } from "./lib/financial-data/canada";
import "./App.css";

function RouteTracker() {
  const { pathname } = useLocation();
  useEffect(() => { analytics.pageView(pathname, document.title); }, [pathname]);
  return null;
}

function AppRoutes() {
  const location = useLocation();
  // Process the OAuth callback FIRST (session_id arrives in the URL fragment).
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/calculators" element={<CalculatorsIndex />} />
        <Route path="/calculators/category/:categoryId" element={<CategoryPage />} />
        <Route path="/calculators/:slug" element={<CalculatorPage />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:productId" element={<ProductPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/guru-plus" element={<GuruPlus />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function App() {
  useEffect(() => {
    initGA4();
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/financial-data`)
      .then((res) => applyLiveData(res.data))
      .catch(() => { /* fall back to static defaults */ });
  }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
        <RouteTracker />
        <AppRoutes />
        <AuthModal />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
